/* BELLA NOTTE — שורות מתנה בעגלה.
   1. שורה שמחירה בפועל 0 — מקבלת .bn-gift-line: המחיר הקודם נמחק
      מהתצוגה ונשאר 0 שקלים בלבד, בזהב.
   2. שם המבצע מוסתר משורות שלא קיבלו הנחה בפועל.
   3. bnReloadKeepScroll — עזר לרענון שמשמר מיקום גלילה
      (משמש את אפסייל החזייה).

   הערה: בורר המתנה לא משתמש ב-JS בכלל — הוא טופס Shopify רגיל.
   הקובץ הזה רק מעצב את התוצאה אחרי שהמתנה כבר בעגלה. */

(function () {
  var KEY = 'bnKeepScroll';

  if (!window.bnReloadKeepScroll) {
    window.bnReloadKeepScroll = function (anchorSelector) {
      try {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        sessionStorage.setItem(KEY, JSON.stringify({ y: y, a: anchorSelector || '' }));
      } catch (e) {}
      window.location.reload();
    };
  }

  function restoreScroll() {
    var raw;
    try { raw = sessionStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(KEY); } catch (e) {}

    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }

    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }

    var tries = 0;
    function go() {
      tries++;
      var target = null;
      if (data.a) {
        var el = document.querySelector(data.a);
        if (el) target = el.getBoundingClientRect().top + window.pageYOffset - 120;
      }
      if (target === null) target = data.y;
      window.scrollTo(0, Math.max(0, target));
      if (tries < 6) setTimeout(go, 120);
    }
    go();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScroll);
  } else {
    restoreScroll();
  }

  if (window.__bnGiftLine) return;
  window.__bnGiftLine = true;

  var running = false;

  function rowFor(el) {
    return el.closest('.cart-items__table-row, .cart-item, tr, li');
  }

  function apply(map) {
    var links = document.querySelectorAll('a[href*="variant="]');
    Array.prototype.forEach.call(links, function (a) {
      var m = a.getAttribute('href').match(/variant=(\d+)/);
      if (!m) return;
      var row = rowFor(a);
      if (!row) return;
      var data = map[m[1]];
      if (!data) return;

      if (data.free) row.classList.add('bn-gift-line');
      else row.classList.remove('bn-gift-line');

      if (!data.titles.length) return;
      var items = row.querySelectorAll('.cart-items__variants-wrapper li, .cart-item__discounted-prices li');
      Array.prototype.forEach.call(items, function (li) {
        var txt = (li.textContent || '').trim();
        if (data.titles.indexOf(txt) !== -1 && !data.discounted) {
          li.style.display = 'none';
        }
      });
    });
  }

  function refresh() {
    if (running) return;
    if (!document.querySelector('a[href*="variant="]')) return;
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var map = {};
        (cart.items || []).forEach(function (i) {
          var allocs = i.line_level_discount_allocations || [];
          map[String(i.variant_id)] = {
            free: i.final_line_price === 0,
            discounted: allocs.some(function (a) { return a.amount > 0; }),
            titles: allocs.map(function (a) {
              return (a.discount_application && a.discount_application.title) || '';
            })
          };
        });
        apply(map);
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  var last = 0, pending = null;
  function throttled() {
    var now = Date.now();
    if (now - last >= 250) { last = now; refresh(); return; }
    if (pending) return;
    pending = setTimeout(function () { pending = null; last = Date.now(); refresh(); }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  [200, 600, 1500].forEach(function (ms) { setTimeout(refresh, ms); });
  document.addEventListener('cart:update', throttled);
  new MutationObserver(throttled).observe(document.documentElement, { childList: true, subtree: true });
})();
